"use client";

import React, { useState } from "react";
import { LazyMotion, domAnimation, m, useReducedMotion } from "framer-motion";
import "./Home.css";

const Arrow = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M5 12h14m-6-6 6 6-6 6" stroke="currentColor" strokeWidth="1.5" />
  </svg>
);

const CheckIcon = () => (
  <svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" className="elyx-check-icon">
    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
  </svg>
);

const PORTFOLIO_PROJECTS = [
  {
    slug: "malongo-armenia",
    name: "Malongo Armenia",
    category: "ecommerce",
    url: "https://malongo.am/",
    industry: {
      hy: "Սուրճ / Առցանց վաճառք",
      ru: "Кофе / Интернет-магазин",
      en: "Coffee / Online retail",
    },
    summary: {
      hy: "Սուրճի բրենդի կայք՝ բաժիններով կատալոգով և զամբյուղի տեսանելի գործիքներով։",
      ru: "Сайт кофейного бренда с каталогом по категориям и видимыми элементами корзины.",
      en: "A coffee brand experience with a categorized product catalog and visible basket controls.",
    },
  },
  {
    slug: "karlione",
    name: "Karlione",
    category: "restaurants",
    url: "https://www.karlione.am/",
    industry: {
      hy: "Ռեստորան / Պիցցա և խորոված",
      ru: "Ресторан / Пицца и блюда на мангале",
      en: "Hospitality / Pizza & barbecue",
    },
    summary: {
      hy: "Ռեստորանային կայք՝ պիցցայի, խորովածի և մենյուի նավարկման միասնական բրենդային ներկայացմամբ։",
      ru: "Ресторанный сайт, объединяющий пиццу, блюда на мангале и навигацию по меню в узнаваемом стиле.",
      en: "A restaurant website bringing pizza, barbecue and menu navigation into a recognizable brand experience.",
    },
  },
  {
    slug: "nile-cosmetics",
    name: "Nilè Cosmetics",
    category: "brand",
    url: "https://nile-cosmetics.com/ru",
    industry: {
      hy: "Գեղեցկություն / Կոսմետիկայի բրենդ",
      ru: "Красота / Косметический бренд",
      en: "Beauty / Cosmetics brand",
    },
    summary: {
      hy: "Կոսմետիկայի բրենդի զուսպ կայք՝ տեսողական պատմությամբ, տեսականու և աշխատանքի բաժինների նավարկմամբ։",
      ru: "Лаконичный сайт косметического бренда с визуальной историей, переходами к ассортименту и карьере.",
      en: "A restrained beauty-brand website pairing visual storytelling with collection and career navigation.",
    },
  },
  {
    slug: "pascali",
    name: "Pascali",
    category: "restaurants",
    url: "https://pascali.am/",
    industry: {
      hy: "Հյուրընկալություն / Սրճարանի մենյու",
      ru: "Гостеприимство / Меню кафе",
      en: "Hospitality / Café menu",
    },
    summary: {
      hy: "Բրաուզերում բացվող սրճարանի մենյու՝ տեսողական բաժիններով և հայերեն/անգլերեն անվանումներով։",
      ru: "Меню кафе в браузере с визуальными категориями и названиями позиций на армянском и английском.",
      en: "A browser-based café menu with visual categories and Armenian/English item names.",
    },
  },
  {
    slug: "bombon",
    name: "Bombon",
    category: "restaurants",
    url: "https://bombon.am/",
    industry: {
      hy: "Ռեստորան / QR պատվերի մուտք",
      ru: "Ресторан / Вход в QR-заказ",
      en: "Hospitality / QR ordering entry",
    },
    summary: {
      hy: "Ռեստորանային պատվերի մեկնարկային էկրան՝ տեղի համարի մուտքագրմամբ և QR սկանավորման տարբերակով։",
      ru: "Стартовый экран ресторанного заказа с вводом номера места и возможностью QR-сканирования.",
      en: "A restaurant ordering entry screen built around a location identifier and a QR-scanning option.",
    },
  },
  {
    slug: "artshat-eco-garden",
    name: "Artshat Eco Garden",
    category: "restaurants",
    url: "https://www.artshatecogarden.com/",
    industry: {
      hy: "Հյուրընկալություն / Ռեստորանի մենյու",
      ru: "Гостеприимство / Ресторанное меню",
      en: "Hospitality / Restaurant menu",
    },
    summary: {
      hy: "Ռեստորանի լուսանկարներով մենյու՝ բաժիններով և ուտեստների հայերեն ու ռուսերեն անվանումներով։",
      ru: "Ресторанное меню с фотографиями, категориями и названиями блюд на армянском и русском.",
      en: "A photo-led restaurant menu with Armenian/Russian dish names and category navigation.",
    },
  },
  {
    slug: "amragrir",
    name: "Amragrir",
    category: "business",
    url: "https://amragrir.online/?lang=en",
    industry: {
      hy: "Բիզնես ծրագրեր / Առցանց ամրագրում",
      ru: "Бизнес-программы / Онлайн-запись",
      en: "Business software / Online booking",
    },
    summary: {
      hy: "Առցանց ամրագրման հարթակ՝ հաճախորդների, մասնագետների և ժամանակացույցի կառավարման ներկայացմամբ։",
      ru: "Платформа онлайн-записи с публичным представлением управления клиентами, специалистами и расписанием.",
      en: "An online booking platform presenting customer, specialist and schedule management.",
    },
  },
  {
    slug: "elyx-smart-order",
    name: "ELYX Smart Order",
    category: "business",
    url: "https://order.elyx.work/",
    industry: {
      hy: "Բիզնես ծրագրեր / Ռեստորանի աշխատանք",
      ru: "Бизнес-программы / Работа ресторана",
      en: "Business software / Restaurant operations",
    },
    summary: {
      hy: "Ռեստորանի հարթակ՝ մատուցողի, խոհանոցի և ադմինիստրատորի աշխատանքային բաժինների տեսանելի մուտքերով։",
      ru: "Ресторанная платформа с видимыми входами в рабочие области официанта, кухни и администратора.",
      en: "A restaurant platform with visible entry points for waiter, kitchen and administration workflows.",
    },
  },
];

const CATEGORY_NAMES = {
  all: { hy: "Բոլորը (8)", ru: "Все (8)", en: "All (8)" },
  ecommerce: { hy: "Առցանց խանութ", ru: "Интернет-магазин", en: "E-Commerce" },
  restaurants: { hy: "Ռեստորաններ և մենյուներ", ru: "Рестораны и меню", en: "Restaurants & Menus" },
  brand: { hy: "Բրենդային կայքեր", ru: "Брендовые сайты", en: "Brand Websites" },
  business: { hy: "Բիզնես համակարգեր", ru: "Бизнес-платформы", en: "Business Platforms" },
};

function ServiceShowcase({ services }) {
  return (
    <div className="elyx-service-grid">
      {services.map((service, index) => (
        <details className="elyx-service" key={service.title} open={index === 0}>
          <summary>
            <span className="elyx-index">{String(index + 1).padStart(2, "0")}</span>
            <span>{service.title}</span>
            <span className="elyx-service-toggle" aria-hidden="true">+</span>
          </summary>
          <p>{service.description}</p>
        </details>
      ))}
    </div>
  );
}

function DigitalEcosystemShowcase({ copy: c, locale }) {
  const [activeTab, setActiveTab] = useState("overview");
  const [cartCount, setCartCount] = useState(2);
  const [activeTable, setActiveTable] = useState("04");

  return (
    <div className="elyx-eco-showcase" id="ecosystem-showcase">
      {/* Decorative ambient depth layer referencing hero1.jpg */}
      <div className="elyx-eco-backdrop" aria-hidden="true">
        <img
          src="/home/hero1.jpg"
          alt=""
          width="1920"
          height="1080"
          loading="lazy"
          className="elyx-eco-backdrop-img"
        />
        <div className="elyx-eco-backdrop-tint" />
      </div>

      {/* Interactive Controls Bar */}
      <div className="elyx-eco-nav" role="tablist" aria-label={c.ecoBrowserBadge}>
        {[
          { id: "overview", label: c.ecoTabOverview },
          { id: "ecommerce", label: c.ecoTabEcommerce },
          { id: "booking", label: c.ecoTabBooking },
          { id: "operations", label: c.ecoTabOperations },
        ].map((tab) => (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={activeTab === tab.id}
            className={`elyx-eco-tab ${activeTab === tab.id ? "is-active" : ""}`}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Main Stage: Central Browser Window + Overlapping Subpanels */}
      <div className="elyx-eco-stage">
        {/* Central Floating Browser Window */}
        <div className="elyx-eco-browser">
          <div className="elyx-browser-chrome">
            <div className="elyx-browser-dots" aria-hidden="true">
              <span className="dot dot-close" />
              <span className="dot dot-min" />
              <span className="dot dot-expand" />
            </div>
            <div className="elyx-browser-address">
              <span className="elyx-ssl-icon" aria-hidden="true">🔒</span>
              <span className="elyx-address-text">hub.elyx.work/ecosystem</span>
            </div>
            <div className="elyx-browser-status">
              <span className="elyx-status-pulse" aria-hidden="true" />
              <span className="elyx-status-label">{c.ecoStatus}</span>
            </div>
          </div>

          <div className="elyx-browser-body">
            {activeTab === "overview" && (
              <div className="elyx-eco-view-overview">
                <div className="elyx-eco-header">
                  <div>
                    <span className="elyx-kicker">{c.ecoBrowserBadge}</span>
                    <h3 className="elyx-eco-h3">{c.workTitle}</h3>
                    <p className="elyx-eco-lede">{c.workIntro}</p>
                  </div>
                  <div className="elyx-uptime-pill">
                    <strong>99.98%</strong>
                    <span>Edge Cloud Uptime</span>
                  </div>
                </div>

                <div className="elyx-eco-modules-grid">
                  <div className="elyx-module-card is-active">
                    <div className="elyx-module-head">
                      <span className="elyx-module-badge">01</span>
                      <h4>{c.ecoEcomTitle}</h4>
                    </div>
                    <p>{c.ecoEcomDesc}</p>
                    <ul className="elyx-module-features">
                      <li><CheckIcon /> Dynamic Product Catalog</li>
                      <li><CheckIcon /> Integrated Shopping Cart</li>
                      <li><CheckIcon /> Local & Global Payments</li>
                    </ul>
                  </div>

                  <div className="elyx-module-card">
                    <div className="elyx-module-head">
                      <span className="elyx-module-badge">02</span>
                      <h4>{c.ecoBookingTitle}</h4>
                    </div>
                    <p>{c.ecoBookingDesc}</p>
                    <ul className="elyx-module-features">
                      <li><CheckIcon /> Interactive QR Menus</li>
                      <li><CheckIcon /> Table & Guest Management</li>
                      <li><CheckIcon /> Real-time Staff Flow</li>
                    </ul>
                  </div>

                  <div className="elyx-module-card">
                    <div className="elyx-module-head">
                      <span className="elyx-module-badge">03</span>
                      <h4>{c.ecoOpsTitle}</h4>
                    </div>
                    <p>{c.ecoOpsDesc}</p>
                    <ul className="elyx-module-features">
                      <li><CheckIcon /> Multilingual Content (AM/RU/EN)</li>
                      <li><CheckIcon /> Real-time WebSocket Sync</li>
                      <li><CheckIcon /> Enterprise Cloud Security</li>
                    </ul>
                  </div>
                </div>
              </div>
            )}

            {activeTab === "ecommerce" && (
              <div className="elyx-eco-view-domain">
                <div className="elyx-domain-bar">
                  <h4>{c.ecoEcomTitle}</h4>
                  <span className="elyx-tag-mint">Live Catalog Active</span>
                </div>
                <div className="elyx-ecom-preview-grid">
                  <div className="elyx-preview-product">
                    <div className="elyx-product-badge">Specialty Retail</div>
                    <h5>Coffee Bean Selection</h5>
                    <p className="elyx-product-price">֏ 4,800 · 250g</p>
                    <div className="elyx-product-status">✓ Fresh Roast · In Stock</div>
                  </div>
                  <div className="elyx-preview-product">
                    <div className="elyx-product-badge">Cosmetics Line</div>
                    <h5>Restorative Face Serum</h5>
                    <p className="elyx-product-price">֏ 12,500 · 50ml</p>
                    <div className="elyx-product-status">✓ Natural Ingredients · In Stock</div>
                  </div>
                  <div className="elyx-preview-product">
                    <div className="elyx-product-badge">Artisan Pastry</div>
                    <h5>French Macaron Box</h5>
                    <p className="elyx-product-price">֏ 3,200 · 6 pcs</p>
                    <div className="elyx-product-status">✓ Daily Fresh Batch · In Stock</div>
                  </div>
                </div>
              </div>
            )}

            {activeTab === "booking" && (
              <div className="elyx-eco-view-domain">
                <div className="elyx-domain-bar">
                  <h4>{c.ecoBookingTitle}</h4>
                  <span className="elyx-tag-mint">Table & Menu Gateway</span>
                </div>
                <div className="elyx-booking-preview-grid">
                  <div className="elyx-table-card is-selected">
                    <div className="elyx-table-num">Table 04</div>
                    <div className="elyx-table-info">Indoor Dining · 4 Guests</div>
                    <div className="elyx-table-status">QR Menu Scanned · Active</div>
                  </div>
                  <div className="elyx-table-card">
                    <div className="elyx-table-num">Table 08</div>
                    <div className="elyx-table-info">Terrace Garden · 2 Guests</div>
                    <div className="elyx-table-status">Order Dispatched to Bar</div>
                  </div>
                  <div className="elyx-table-card">
                    <div className="elyx-table-num">Slot 15:30</div>
                    <div className="elyx-table-info">Service Appointment · Specialist</div>
                    <div className="elyx-table-status">Confirmed via SMS</div>
                  </div>
                </div>
              </div>
            )}

            {activeTab === "operations" && (
              <div className="elyx-eco-view-domain">
                <div className="elyx-domain-bar">
                  <h4>{c.ecoOpsTitle}</h4>
                  <span className="elyx-tag-mint">Unified Core</span>
                </div>
                <div className="elyx-ops-status-grid">
                  <div className="elyx-ops-stat">
                    <span className="elyx-stat-label">Localized Languages</span>
                    <span className="elyx-stat-val">Armenian · Russian · English</span>
                  </div>
                  <div className="elyx-ops-stat">
                    <span className="elyx-stat-label">API Response Latency</span>
                    <span className="elyx-stat-val">&lt; 65ms Global Edge</span>
                  </div>
                  <div className="elyx-ops-stat">
                    <span className="elyx-stat-label">Content Synchronization</span>
                    <span className="elyx-stat-val">Zero Downtime Deployments</span>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Overlapping E-Commerce Subpanel */}
        <aside className="elyx-eco-subpanel elyx-ecom-panel" aria-label="E-Commerce Live Preview">
          <div className="elyx-subpanel-header">
            <span className="elyx-subpanel-title">Online Storefront</span>
            <span className="elyx-cart-pill" aria-label={`Cart contains ${cartCount} items`}>
              🛒 {cartCount}
            </span>
          </div>
          <div className="elyx-subpanel-card">
            <div className="elyx-subpanel-meta">
              <span className="elyx-subpanel-category">Retail Order Flow</span>
              <h6>Specialty Roast Beans</h6>
              <p className="elyx-subpanel-price">֏ 4,800</p>
            </div>
            <button
              type="button"
              className="elyx-subpanel-action"
              onClick={() => setCartCount((prev) => prev + 1)}
            >
              + Add to Basket
            </button>
          </div>
          <div className="elyx-subpanel-footer">
            <span className="elyx-mini-dot" /> Instant Basket Sync
          </div>
        </aside>

        {/* Overlapping Booking / QR Menu Subpanel */}
        <aside className="elyx-eco-subpanel elyx-booking-panel" aria-label="Booking and QR Menu Flow">
          <div className="elyx-subpanel-header">
            <span className="elyx-subpanel-title">QR Menu &amp; Tables</span>
            <span className="elyx-qr-badge">SCAN &amp; GO</span>
          </div>
          <div className="elyx-subpanel-card">
            <div className="elyx-qr-mini-vis" aria-hidden="true">
              <div className="elyx-qr-box">
                <span className="elyx-qr-corner c1" />
                <span className="elyx-qr-corner c2" />
                <span className="elyx-qr-corner c3" />
                <span className="elyx-qr-scan-line" />
              </div>
            </div>
            <div className="elyx-subpanel-meta">
              <span className="elyx-subpanel-category">Guest Dining Flow</span>
              <h6>Table #{activeTable} · Active Guest</h6>
              <div className="elyx-table-selector">
                {["02", "04", "07"].map((num) => (
                  <button
                    key={num}
                    type="button"
                    className={`elyx-table-chip ${activeTable === num ? "is-selected" : ""}`}
                    onClick={() => setActiveTable(num)}
                  >
                    T{num}
                  </button>
                ))}
              </div>
            </div>
          </div>
          <div className="elyx-subpanel-footer">
            <span className="elyx-mini-dot" /> Browser native · No app needed
          </div>
        </aside>
      </div>
    </div>
  );
}

function PortfolioSection({ copy: c, locale, links, lift }) {
  const [selectedFilter, setSelectedFilter] = useState("all");

  const filteredProjects =
    selectedFilter === "all"
      ? PORTFOLIO_PROJECTS
      : PORTFOLIO_PROJECTS.filter((p) => p.category === selectedFilter);

  return (
    <div className="elyx-portfolio-section">
      <div className="elyx-section-head">
        <p className="elyx-kicker">{c.portfolioLabel}</p>
        <div>
          <h2 id="elyx-portfolio-title">{c.portfolioHeading}</h2>
          <p>{c.portfolioSub}</p>
        </div>
      </div>

      {/* Filter Tabs */}
      <div className="elyx-portfolio-filters" role="tablist" aria-label="Portfolio filters">
        {Object.entries(CATEGORY_NAMES).map(([key, labels]) => (
          <button
            key={key}
            type="button"
            role="tab"
            aria-selected={selectedFilter === key}
            className={`elyx-filter-btn ${selectedFilter === key ? "is-active" : ""}`}
            onClick={() => setSelectedFilter(key)}
          >
            {labels[locale] || labels.en}
          </button>
        ))}
      </div>

      {/* 8 Projects Grid */}
      <div className="elyx-portfolio-grid">
        {filteredProjects.map((project) => {
          const industryText = project.industry[locale] || project.industry.en;
          const summaryText = project.summary[locale] || project.summary.en;

          return (
            <m.article
              className="elyx-portfolio-card"
              key={project.slug}
              whileHover={lift}
              transition={{ duration: 0.2 }}
            >
              <div className="elyx-card-browser">
                <div className="elyx-card-topbar">
                  <span className="elyx-browser-dot dot-red" />
                  <span className="elyx-browser-dot dot-yellow" />
                  <span className="elyx-browser-dot dot-green" />
                  <span className="elyx-card-url">{project.url.replace(/^https?:\/\//, "")}</span>
                </div>

                <a
                  href={project.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="elyx-card-media"
                  aria-label={`${project.name} — ${c.visitLive}`}
                >
                  <img
                    src={`/images/portfolio/${project.slug}/desktop.webp`}
                    alt={`${project.name} desktop website view`}
                    width="1440"
                    height="900"
                    loading="lazy"
                    className="elyx-card-desktop-img"
                  />
                  <div className="elyx-card-mobile-frame" aria-hidden="true">
                    <img
                      src={`/images/portfolio/${project.slug}/mobile.webp`}
                      alt=""
                      width="390"
                      height="844"
                      loading="lazy"
                      className="elyx-card-mobile-img"
                    />
                  </div>
                </a>
              </div>

              <div className="elyx-card-content">
                <div className="elyx-card-tags">
                  <span className="elyx-industry-badge">{industryText}</span>
                  <span className="elyx-status-live">Live</span>
                </div>
                <h3 className="elyx-card-title">{project.name}</h3>
                <p className="elyx-card-desc">{summaryText}</p>
                <div className="elyx-card-actions">
                  <a
                    className="elyx-button-small"
                    href={project.url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span>{c.visitLive}</span>
                    <Arrow />
                  </a>
                  <a className="elyx-text-link" href={links.portfolio}>
                    <span>{c.viewCase}</span>
                    <Arrow />
                  </a>
                </div>
              </div>
            </m.article>
          );
        })}
      </div>
    </div>
  );
}

export default function PremiumHome({ copy: c, messages: t, locale, links }) {
  const reducedMotion = useReducedMotion();
  const lift = reducedMotion ? undefined : { y: -4 };

  return (
    <LazyMotion features={domAnimation} strict>
      <div className="elyx-home" lang={locale}>
        {/* Top Hero Section */}
        <section className="elyx-hero elyx-container" id="top" aria-labelledby="elyx-hero-title">
          <div className="elyx-hero-copy">
            <p className="elyx-kicker">
              <span className="elyx-status" aria-hidden="true" />
              {c.eyebrow}
            </p>
            <h1 id="elyx-hero-title">
              {c.headline}
              <br />
              <span>{c.accent}</span>
            </h1>
            <p className="elyx-intro">{c.intro}</p>
            <div className="elyx-actions">
              <a className="elyx-button" href={links.contact}>
                {c.contact}
                <Arrow />
              </a>
              <a className="elyx-text-link" href="#products">
                {c.portfolio}
                <Arrow />
              </a>
            </div>
            <p className="elyx-local">
              <span aria-hidden="true">↳</span> {c.local}
            </p>
          </div>

          {/* Hero Stage with Multi-Device Ecosystem visual referencing hero2.jpg */}
          <m.div
            className="elyx-hero-stage"
            initial={false}
            animate={reducedMotion ? undefined : { y: [10, 0] }}
            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          >
            <div className="elyx-stage-top">
              <span>{c.preview}</span>
              <span aria-hidden="true">↗</span>
            </div>
            <div className="elyx-hero-device-wrapper">
              <img
                src="/home/hero2.jpg"
                alt={c.photoAlt}
                width="1100"
                height="619"
                fetchPriority="high"
                className="elyx-hero-main-img"
              />
              <div className="elyx-hero-stage-badge">
                <span className="elyx-status-pulse" aria-hidden="true" />
                <span>{c.ecoStatus}</span>
              </div>
            </div>
            <div className="elyx-stage-mark" aria-hidden="true">
              e<span>↗</span>
            </div>
          </m.div>
        </section>

        {/* Capability Strip */}
        <div className="elyx-capability-strip">
          <div className="elyx-container">
            {t.agency.services.slice(0, 4).map((service) => (
              <span key={service.title}>{service.title}</span>
            ))}
          </div>
        </div>

        {/* Services Section */}
        <section className="elyx-section elyx-container" id="services" aria-labelledby="elyx-services-title">
          <div className="elyx-section-head">
            <p className="elyx-kicker">{c.servicesLabel}</p>
            <div>
              <h2 id="elyx-services-title">{c.servicesTitle}</h2>
              <p>{c.servicesIntro}</p>
            </div>
          </div>
          <ServiceShowcase services={t.agency.services} />
          <div className="elyx-section-foot">
            <p>{c.quote}</p>
            <a className="elyx-text-link" href={links.services}>
              {t.services_header}
              <Arrow />
            </a>
          </div>
        </section>

        {/* Featured Work Band: Light, Fresh, Interactive ELYX Digital Ecosystem + 8 Projects */}
        <section className="elyx-work-band" id="products" aria-labelledby="elyx-work-title">
          <div className="elyx-container elyx-section">
            <div className="elyx-section-head">
              <p className="elyx-kicker">{c.workLabel}</p>
              <div>
                <h2 id="elyx-work-title">{c.workTitle}</h2>
                <p>{c.workIntro}</p>
              </div>
            </div>

            {/* Interactive ELYX Digital Ecosystem Showcase */}
            <DigitalEcosystemShowcase copy={c} locale={locale} />

            {/* 8 Real Portfolio Projects Showcase */}
            <PortfolioSection copy={c} locale={locale} links={links} lift={lift} />

            <div className="elyx-section-foot">
              <a className="elyx-text-link" href={links.portfolio}>
                {c.allCases}
                <Arrow />
              </a>
              <a className="elyx-text-link" href={`/qr-menu-demo?lang=${locale}`}>
                QR Menu Demo
                <Arrow />
              </a>
            </div>

            <aside className="elyx-tools">
              <div>
                <h3>{c.tools}</h3>
                <p>{c.toolsText}</p>
              </div>
              <div>
                <a href={`https://htmltagss.com/?lang=${locale}`} target="_blank" rel="noopener noreferrer">
                  HTML Tags ↗
                </a>
                <a href={`https://htmltagss.com/ColorGenerator?lang=${locale}`} target="_blank" rel="noopener noreferrer">
                  Color Generator ↗
                </a>
              </div>
            </aside>
          </div>
        </section>

        {/* Process Section */}
        <section className="elyx-section elyx-container" id="about" aria-labelledby="elyx-process-title">
          <div className="elyx-section-head">
            <p className="elyx-kicker">{c.processLabel}</p>
            <h2 id="elyx-process-title">{c.processTitle}</h2>
          </div>
          <ol className="elyx-process" id="features">
            {c.steps.map((step, i) => (
              <li key={step.title}>
                <span className="elyx-process-number" aria-hidden="true">
                  0{i + 1}
                </span>
                <h3>{step.title}</h3>
                <p>{step.text}</p>
              </li>
            ))}
          </ol>
        </section>

        {/* FAQ Section */}
        <section className="elyx-faq elyx-container" id="faq" aria-labelledby="elyx-faq-title">
          <h2 id="elyx-faq-title">{c.faqTitle}</h2>
          <div>
            {t.agency.faqs.map((faq) => (
              <details key={faq.question}>
                <summary>{faq.question}</summary>
                <p>{faq.answer}</p>
              </details>
            ))}
          </div>
        </section>

        {/* Contact Band */}
        <section className="elyx-contact-band elyx-container" aria-labelledby="elyx-contact-title">
          <p className="elyx-kicker">{c.endLabel}</p>
          <h2 id="elyx-contact-title">{c.endTitle}</h2>
          <p>{c.endText}</p>
          <div className="elyx-actions">
            <a className="elyx-button" href={links.contact}>
              {c.contact}
              <Arrow />
            </a>
            <a className="elyx-text-link" href="mailto:cto@elyx.work">
              {c.email}
              <Arrow />
            </a>
            <a className="elyx-text-link" href="tel:+37443099070">
              {c.phone}
              <Arrow />
            </a>
          </div>
        </section>

        {/* Resources Link */}
        <div className="elyx-resource-link elyx-container" id="resources">
          <a href={`/resources?lang=${locale}`}>{c.resources} ↗</a>
        </div>
      </div>
    </LazyMotion>
  );
}
